import React from 'react';
import { EventType } from '../../CalendarTypes';
import { ContentHeadline } from '../../../../_lib/components/ContentHeadline';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ContentLink } from '../../../../_lib/components/ContentLink';
import { InvisiblyDefinedTerm } from '../../../../_lib/components/InvisiblyDefinedTerm';

type CalendarEventListType = {
  eventListId: string;
  eventsToShow: EventType[];
  parseSelectedDate: (dateOfEvent: string) => string;
};

export function CalendarEventList({ eventListId, eventsToShow, parseSelectedDate }: CalendarEventListType) {
  const { t } = useSonTranslation('glossary');
  return (
    <div className="calendar__event-list-container" id={eventListId}>
      {eventsToShow.length > 0 && (
        <>
          <ContentHeadline title={parseSelectedDate(eventsToShow[0].date)} hierarchy={3} />
          <ol className="calendar__event-list">
            {eventsToShow.map((eventItem: EventType) => (
              <li
                key={eventItem.url}
                className="calendar__event-list-item"
                style={
                  eventItem.categories && eventItem.categories.length > 0
                    ? { borderColor: eventItem.categories[0].hexColor }
                    : undefined
                }
              >
                {eventItem.categories && eventItem.categories.length > 0 && (
                  <InvisiblyDefinedTerm
                    className="calendar__event-category"
                    definition={t(`category${eventItem.categories.length > 1 ? '_plural' : ''}`)}
                  >
                    {eventItem.categories.map(el => el.title).join(', ')}
                  </InvisiblyDefinedTerm>
                )}
                {eventItem.url && <ContentLink to={eventItem.url}>{eventItem.title}</ContentLink>}
              </li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}
